import checkTypes from './checkTypes.js';
import json from './json.js';

/**
 * Set property on avastGlobals.cart object
 * @param {string} keyName
 * @param {object} sourceObject
 * @returns {string}
 */
export default (keyName, sourceObject) => {
	checkTypes('setGlobalItem', {
		keyName: [keyName, 'string'],
		sourceObject: [sourceObject, 'object']
	});
	return `
		window.avastGlobals = window.avastGlobals || {};
		window.avastGlobals.cart = window.avastGlobals.cart || {};
		window.avastGlobals.cart.${keyName} = ${json.stringify(sourceObject, null, '\t')};
	`;
};
